const page = 'product-management';

export default [
    {
        path: '/product-and-management',
        name: 'nav-product-and-management-landing-page',
        exact: true,
        component: () => import('@/pages/item/ProductAndManagementNavLandingPage.vue'),
        meta: {
            auth: true,
            permission: ['item.access'],
            nimbusPageType: 'nav-landing-page'
        },
        children: [
            {
                path: '/item',
                name: 'Items',
                exact: true,
                component: () => import('@/pages/item/Index.vue'),
                meta: {
                    auth: true,
                    permission: ['item.access'],
                },
            },
            {
                path: '/item/:id',
                name: 'View Item',
                exact: true,
                component: () => import('@/pages/item/View.vue'),
                redirect: {
                    name: `${page}-item-pricing`,
                },
                meta: {
                    auth: true,
                    permission: ['item.view'],
                },
                children: [
                    {
                        path: 'item-pricing',
                        name: `${page}-item-pricing`,
                        component: () => import('@/pages/item/details/tabs/ItemPricingTab.vue'),
                        meta: {
                            title: 'Item Pricing',
                            permission: ['item.view'],
                        },
                    },
                    {
                        path: 'attributes',
                        name: `${page}-attributes`,
                        component: () => import('@/pages/item/details/tabs/AttributesTab.vue'),
                        meta: {
                            title: 'Attribute',
                            permission: ['item.view'],
                        },
                    },
                ],
            },
        ]
    },

];
